import React from "react";
import Header from "../common/header";
import { VerticalMenu } from "../verticallayout";
import { Paper } from "@mantine/core";
import BreadcrumbNav from "../common/breadcrumb";

const NavBar = ({ orientation, children }: any) => {
    const currentPath = window.location.pathname;    
    return (
        <div>
            {orientation === "vertical" ? (
                 <div><VerticalMenu>{children}</VerticalMenu></div>
            ) : (
                <div>
                  <Header /> 
                    <div className="w-full flex flex-col"  style={{ height: 'calc(100vh - 50px)'}}>
                        <Paper className="h-full flex-1 flex-col" style={{
                             background: 'transparent linear-gradient(118deg, #FFFFFF 0%, #F0F7FF 43%, #DFE8F4 78%, #C2DBFA 100%) 0% 0% no-repeat padding-box',
                             overflowY: 'auto'        
                             }}>
                             {currentPath !== '/client' && <BreadcrumbNav />}
                            {children}
                        </Paper>
                    </div>
                </div>
            )}
        </div>
    );
}

export default NavBar;